import './Theme.FileInput.Dropzone.scss';
export default `themeFileInputDropzone`;
